<template>
    <a-select
        :get-popup-container="getPopupContainer"
        placeholder="请选择"
        mode="multiple"
        :value="valueArray"
        @update:value="onUpdateValue"
        style="width: 100%"
    >
        <a-select-option
            v-for="item in options"
            :key="item[dictValue]"
            :value="item[dictValue]"
            :disabled="item.disabled ? item.disabled : false"
        >
            {{ item[dictLabel] }}
        </a-select-option>
    </a-select>
</template>

<script>
import {computed} from "vue";

export default {
    name: "MultipleSelect",
    emits: ["update:value"],
    props: {
        value: {
            type: [String, Number],
            default: null,
        },
        options: {
            type: Array,
            default() {
                return [];
            },
        },
        dictLabel: {
            type: String,
            default: "dictLabel",
        },
        dictValue: {
            type: String,
            default: "dictValue",
        },
    },
    setup(props, {emit}) {
        const valueArray = computed(() =>
            props.value ? props.value.split(",") : []
        );
        const onUpdateValue = (val) => {
            let value = val.join(",");
            emit("update:value", value);
        };
        return {
            valueArray,
            onUpdateValue,
        };
    },
};
</script>

<style scoped>
</style>
